const actions = {
  setSiteConfig: ({ commit }, config) => {
    return commit('SET_SITE_CONFIG', config);
  },
  setUserLogin: ({ commit }, loginInfo) => {
    return commit('SET_USER_LOGIN', loginInfo);
  },
  setIsBuy: ({ commit }, isBuy) => {
    return commit('SET_IS_BUY', isBuy);
  },
  setUmcId: ({ commit }, umcId) => {
    return commit('SET_UMCID', umcId);
  },
  setDefaultCid: ({ commit }, defaultCid) => {
    return commit('SET_DEFAULTCID', defaultCid);
  },
  setProductId: ({ commit }, productId) => {
    return commit('SET_PRODUCTID', productId);
  },
  setCourseId: ({ commit }, courseId) => {
    return commit('SET_COURSEID', courseId);
  },
  setCourseSpecialId: ({ commit }, courseSpecialId) => {
    return commit('SET_COURSE_SPECIALID', courseSpecialId);
  },
  setCourseCatalog: ({ commit }, courseCatalog) => {
    return commit('SET_COURSE_CATALOG', courseCatalog);
  },
  setReviewCatalog: ({ commit }, reviewCatalog) => {
    return commit('SET_REVIEW_CATALOG', reviewCatalog);
  },
  setReviewPositionName: ({ commit }, positionName) => {
    return commit('SET_REVIEW_POSITION_NAME', positionName);
  },
  setVideoId: ({ commit }, videoId) => {
    return commit('SET_VIDEO_ID', videoId);
  },
  setBuyType: ({ commit }, buyType) => {
    return commit('SET_BUY_TYPE', buyType);
  },
  setCatalogId: ({ commit }, catalogId) => {
    return commit('SET_CATALOG_ID', catalogId);
  },
  setPptId: ({ commit }, pptId) => {
    return commit('SET_PPT_ID', pptId);
  },
  setExerId: ({ commit }, exerId) => {
    return commit('SET_EXER_ID', exerId);
  },
  setUserCourseList: ({ commit }, userCourseList) => {
    return commit('SET_USER_COURSELIST', userCourseList);
  },
  setPlayList: ({ commit }, playList) => {
    return commit('SET_PLAY_LIST', playList);
  },
  setSrfId: ({ commit }, srfId) => {
    return commit('SET_SRF_ID', srfId);
  },
};

export default actions;
